import { styled } from '@mui/material';

export const ImageViewerWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '20px',
  height: '100%',
  overflow: 'auto',
});

export const ImageViewerStateContainer = styled('div')({
  padding: '20px',
  textAlign: 'center',
});

export const ImageViewerContainer = styled('div')({
  border: '1px solid #ddd',
  borderRadius: '8px',
  overflow: 'hidden',
  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  backgroundColor: '#fff',
});

export const ImageViewerImage = styled('img')({
  maxWidth: '100%',
  maxHeight: '100%',
  objectFit: 'contain',
  display: 'block',
});

export const ImageViewerDimensions = styled('div')({
  marginTop: '10px',
  padding: '8px 16px',
  backgroundColor: '#f8f9fa',
  borderRadius: '4px',
  fontSize: '14px',
  color: '#6c757d',
});